import faIR from 'antd/lib/locale/fa_IR';
import { ConfigProvider } from 'antd';
import { memo, useCallback } from 'react';
import { ReserveInfoModal } from '@/components/modals';
import { LoadingSpin, TryAgain } from '@/components/common';
import useModal from '@/hooks/useModal';
import ReserveReportDesktop from './ReserveReportDesktop';
import ReserveReportMobile from './ReserveReportMobile';
import { useDevice } from '@/hooks';

export interface ReserveReportProps {
  loading: boolean;
  error?: string;
  onRetry: () => any;
  reportList?: ReportDayEntity[];
  mealTypeList?: ReserveMealEntity[];
  variant: ComponentVariant;
}

export const ReserveReport = memo(({
  loading,
  error,
  onRetry,
  variant,
  reportList,
  mealTypeList
}: ReserveReportProps) => {
  
  const modal = useModal();
  const { isDesktop } = useDevice();

  const onClick = useCallback((data: any) => {
    
    modal.show(data);
  }, [modal]);
  

  if (error) return <TryAgain text={error} onRetry={onRetry} />;

  return (
    <ConfigProvider direction="rtl" locale={faIR}>
      <div
        style={{ height: isDesktop() ? 'min(60vh, 600px)' : '100%' }}
        className={`w-full reserve-report-${variant} flex flex-col pb-3 overflow-auto lg:!mt-0`}>
        {loading ? <LoadingSpin className={`text-${variant}-darker`} fillHeight /> : (
          <>
            <ReserveInfoModal variant={variant} {...modal} />
            {isDesktop() ?
              <ReserveReportDesktop
                reports={reportList}
                mealTypes={mealTypeList}
                onItemClick={onClick}
              /> : (
                <ReserveReportMobile
                  reports={reportList}
                  mealTypes={mealTypeList}
                  onItemClick={onClick}
                />
              )
            }
          </>
        )}
      </div>
    </ConfigProvider>
  );
});

export default ReserveReport;
